module.exports = __webpack_public_path__ + "static/media/acacia-mall-roof-shot-03.2d133b13.webp";